import styled from 'styled-components';
import { device } from '../../../theme/mediaQueries';

const AddNewContractStyle = styled.div`
  .m-add-new-contract__button-back{
    margin-bottom: 30px;
  }

  .m-add-new-contract__container-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 130px;

    .m-add-new-contract__formulario{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .m-add-new-contract__input{
        width: 100%;
        max-width: 380px;
      }

      .m-add-new-contract__container-button{
        width: 100%;
        text-align: center;
        margin-top: 40px;

        .m-add-new-contract__button--send{
          width: 258px;
          margin-bottom: 25px;
        }
      }
    }
  }

  @media ${device.sm} {
    .m-add-new-contract__container-form {
      max-width: 780px;
      margin: 80px auto 140px;

      .m-add-new-contract__formulario {
        flex-direction: column;
        align-items: center;
        .m-add-new-contract__input{
          width: 370px;
        }

        .m-add-new-contract__container-button  .m-add-new-contract__button--send{
          width: 290px;
        }
      }
    }
  }

  @media ${device.md} {
    .m-add-new-contract__button-back{
      margin-bottom: 0px;
    } 
    .m-add-new-contract__container-form {
      width: 815px;
      max-width: 850px;
    }
  }

  @media ${device.lg} {
    .m-add-new-contract__container-form {
      width: 100%;
      max-width: 1035px;
    }
  }

  @media ${device.xl} {
    .m-add-new-contract__container-form {
      max-width: 1138px;

      .m-add-new-contract__formulario {
        .m-add-new-contract__input{
          width: 430px;
          max-width: 430px;
        }
      }
    }
  }
`
export default AddNewContractStyle;